import { CheckRounded, CopyAllRounded, HdrStrongRounded, JoinFullRounded, JoinInnerRounded, JoinLeftRounded, JoinRightRounded, SensorsRounded } from "@mui/icons-material"
import { Button, LinearProgress } from "@mui/material"
import { useState, useEffect } from "react";

import Text from '@components/Text';
import { t } from '@i18n';

import './styles.scss';


export default function PixInfo({ pixInfo }) {
    const [copied, setCopied] = useState(false)

    function handleCopyCode() {
        if (navigator.clipboard && pixInfo.payload) {
            navigator.clipboard.writeText(pixInfo.payload)
                .then(() => {
                    setCopied(true)
                })
                .catch(err => {
                    console.error('Failed to copy PIX code:', err);
                });
        }
    }

    if (!pixInfo) return null

    return (
        <div className="pix-box mt-4">
            <Text.h5>{t('pix.title')}</Text.h5>
            <Text.small style={{ opacity: 0.7 }}>{t('pix.instructions')}</Text.small>

            <div className="pix-code-box mt-2">
                <Text.small>{t('pix.scanQrCode')}</Text.small>
                <div className="pix-code">
                    <img src={`data:image/png;base64,${pixInfo.encodedImage}`} alt={t('pix.qrAlt')} />
                </div>{/*                <RoundedArdLeft />
                <RoundedArdRight />*/}
            </div>
            <div className="copy-pix-code pt-2">
                <Text.small>{t('pix.copyCode')}</Text.small>

                <div
                    className={"copy-pix-btn mt-1 " + (copied ? 'success' : "")}
                    onClick={handleCopyCode}
                >
                    <Text.small className="pix-code">
                        {pixInfo.payload}
                    </Text.small>
                    <Button
                        variant="text"
                        startIcon={
                            copied ? <CheckRounded sx={{ fontSize: 11 }} /> : <CopyAllRounded sx={{ fontSize: 11 }} />
                        }
                    >
                        <Text.small>
                            {copied ? t('common.copied') : t('common.copy')}
                        </Text.small>
                    </Button>
                </div>
            </div>

            <Timer />
        </div>
    )
}

function Timer() {
    const [progress, setProgress] = useState(100)
    const [timeLeft, setTimeLeft] = useState(383) // 6 minutes and 23 seconds = 383 seconds

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(prevTime => {
                if (prevTime <= 0) {
                    clearInterval(interval)
                    return 0
                }
                return prevTime - 0.1 // Decrease by 0.1 seconds (100ms)
            })
        }, 100)

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        // Calculate progress percentage (100 to 0)
        const totalTime = 383 // 6 minutes and 23 seconds
        const progressPercentage = (timeLeft / totalTime) * 100
        setProgress(progressPercentage)
    }, [timeLeft])

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = Math.floor(seconds % 60)
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
    }

    return (
        <div className="timer mt-2 mb-3">
            <div>
                <Text.span style={{ opacity: 0.7 }}>{t('pix.timeLeft')} </Text.span>
            </div>
            <div className="timer-row mt-1">
                <Text.h3 className="bold">{formatTime(timeLeft)}</Text.h3>
                <Text.span className="real-time">
                    <AnimatedJoinIcon />
                    <Text.small>
                        {t('pix.realtime')}
                    </Text.small>
                </Text.span>
            </div>
            <div className="mt-1">
                <LinearProgress value={progress} variant="determinate" />
            </div>
        </div>
    )
}

function RoundedArdLeft() {
    return (
        <span className="rounded-arc arc-left">
            <span className="rounded-arc-content"></span>
        </span>
    )
}

function RoundedArdRight() {
    return (
        <span className="rounded-arc arc-right">
            <span className="rounded-arc-content"></span>
        </span>
    )
}

function AnimatedJoinIcon() {
    const [currentIcon, setCurrentIcon] = useState(0);

    const icons = [
        <JoinFullRounded className="update-icon" key="full" sx={{ fontSize: 16 }} />,
        <JoinInnerRounded className="update-icon" key="inner" sx={{ fontSize: 16 }} />,
        <JoinLeftRounded className="update-icon" key="left" sx={{ fontSize: 16 }} />,
        <JoinRightRounded className="update-icon" key="right" sx={{ fontSize: 16 }} />
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIcon(prev => (prev + 1) % icons.length);
        }, 800); // Change icon every 800ms

        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ display: 'inline-block' }}>
            {icons[currentIcon]}
        </div>
    );
}
